module.exports = __webpack_public_path__ + "img/05.b8a7205f.png";